<script setup lang="ts">
withDefaults(
  defineProps<{ label: string; amount: string; boxed?: boolean }>(),
  { boxed: true },
);
</script>

<template>
  <div
    class="flex items-center justify-between"
    :class="boxed && 'bg-creux rounded-[16px] px-5 py-[18px]'"
  >
    <p class="text-[14px] leading-[1.4]" :class="boxed && 'font-semibold'">
      {{ label }}
    </p>
    <p class="text-[32px] leading-none font-bold tracking-[-0.4px]">
      {{ amount }}
    </p>
  </div>
</template>
